(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-store-detaile"] && !Shopify.designMode) return;
  try {
    
{
  const Slideshow = class {
    constructor(element) {
      this.container = element;
      if (!this.container || this.container.dataset.slideshowInitialized) {
        return;
      }
      this.container.dataset.slideshowInitialized = 'true';
      
      this.slides = this.container.querySelector('.slideshow-slides');
      this.prevButton = this.container.querySelector('.prev');
      this.nextButton = this.container.querySelector('.next');
      this.slideItems = this.container.querySelectorAll('.slideshow-slide');
      this.slideCount = this.slideItems.length;
      this.currentIndex = 0;
      this.intervalId = null; // 自動再生のタイマーIDを保持

      if (this.slideCount > 1) {
        this.init();
      }
    }

    // 次のスライドへ移動するコアロジック
    next() {
      const nextIndex = (this.currentIndex + 1) % this.slideCount;
      this.goTo(nextIndex);
    }

    // 前のスライドへ移動するコアロジック
    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
      this.goTo(prevIndex);
    }

    // 「次へ」ボタンがクリックされた時の処理
    handleNextClick() {
      this.next();
      this.resetAutoPlay(); // タイマーをリセット
    }

    // 「前へ」ボタンがクリックされた時の処理
    handlePrevClick() {
      this.prev();
      this.resetAutoPlay(); // タイマーをリセット
    }

    // 自動再生を開始する
    startAutoPlay() {
      if (this.intervalId) return; // 既にタイマーが動いている場合は何もしない
      this.intervalId = setInterval(this.next.bind(this), 5000); // 5秒ごとにnext()を呼び出す
    }

    // 自動再生を停止する
    stopAutoPlay() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    // 自動再生をリセット（停止してから再開）する
    resetAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    }

    init() {
      // ボタンのクリックイベント
      this.nextButton.addEventListener('click', this.handleNextClick.bind(this));
      this.prevButton.addEventListener('click', this.handlePrevClick.bind(this));
      
      // マウスホバーで自動再生を停止・再開
      this.container.addEventListener('mouseenter', this.stopAutoPlay.bind(this));
      this.container.addEventListener('mouseleave', this.startAutoPlay.bind(this));

      // 初期状態で自動再生を開始
      this.startAutoPlay();
    }

    goTo(index) {
      this.slides.style.transform = 'translateX(-' + (index * 100) + '%)';
      this.currentIndex = index;
    }
  };

  function initializeAllSlideshows(scope) {
    const slideshowElements = scope.querySelectorAll('.slideshow-wrapper');
    slideshowElements.forEach(element => new Slideshow(element));
  }

  function handleDOMContentLoaded() {
    initializeAllSlideshows(document.body);
  }

  function handleShopifySectionLoad(event) {
    const sectionScope = event.target;
    if (sectionScope && sectionScope.querySelector('.slideshow-wrapper')) {
      initializeAllSlideshows(sectionScope);
    }
  }

  document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
  document.addEventListener('shopify:section:load', handleShopifySectionLoad);
}

  } catch(e) { console.error(e); }
})();
})();
